export default "__VITE_ASSET__C38ZM83l__"